export default __webpack_public_path__ + "static/media/logo.eb0253a2.svg";